// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px; /* Ensure spacing on small screens */
}

.product-form-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 550px;
  /* FIX: Limit height and use flexbox */
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.product-form-modal .modal-header {
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0; /* Header won't shrink */
}

.product-form-modal .modal-header h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.product-form-modal .modal-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
}

/* New wrapper for form content to handle flex structure */
.product-form-modal .modal-form-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden; /* Prevents double scrollbars */
}

/* SCROLLABLE AREA */
.product-form-modal .form-scroll-container {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto; /* Adds scrollbar here */
  flex: 1 1; /* Takes available space */
}

.product-form-modal .form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-form-modal .form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.product-form-modal .form-group input,
.product-form-modal .form-group textarea,
.product-form-modal .form-group select {
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-sizing: border-box;
  font-family: inherit;
}

.product-form-modal .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* FIXED FOOTER */
.product-form-modal .modal-footer {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #e5e7eb;
  background-color: #fff; /* Changed to white to blend better */
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  flex-shrink: 0; /* Footer won't shrink */
}

.product-form-modal .cancel-btn,
.product-form-modal .save-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid;
}

.product-form-modal .cancel-btn {
  background-color: white;
  color: #374151;
  border-color: #d1d5db;
}

.product-form-modal .save-btn {
  background-color: #f97316;
  color: white;
  border-color: #f97316;
}

.product-form-modal .save-btn:disabled {
  background-color: #fdba74;
  border-color: #fdba74;
  cursor: not-allowed;
}

.navo-dialog .product-form-modal .modal-form-content { overflow: visible; }
.navo-dialog .product-form-modal .form-scroll-container { padding: 0; overflow: visible; gap: 18px; }
.product-stock-summary { display: flex; align-items: center; gap: 12px; padding: 12px 14px; border-radius: 10px; background: #f6f9fc; }
.product-stock-summary p { margin: 0; font-size: 13px; line-height: 1.5; color: #64748b; }
@media (max-width: 480px) { .product-form-modal .form-row { grid-template-columns: 1fr; } .product-stock-summary { align-items: flex-start; flex-direction: column; } }
`, "",{"version":3,"sources":["webpack://./src/compoonents/ProductFormModal/ProductFormModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa,EAAE,oCAAoC;AACrD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB,EAAE,wBAAwB;EAC1C,SAAO,EAAE,0BAA0B;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,6BAA6B;EAC7B,sBAAsB,EAAE,qCAAqC;EAC7D,+BAA+B;EAC/B,gCAAgC;EAChC,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,uDAAuD,iBAAiB,EAAE;AAC1E,0DAA0D,UAAU,EAAE,iBAAiB,EAAE,SAAS,EAAE;AACpG,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACtI,2BAA2B,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzF,4BAA4B,gCAAgC,0BAA0B,EAAE,EAAE,yBAAyB,uBAAuB,EAAE,sBAAsB,EAAE,EAAE","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px; /* Ensure spacing on small screens */\n}\n\n.product-form-modal {\n  background: white;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 550px;\n  /* FIX: Limit height and use flexbox */\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.product-form-modal .modal-header {\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0; /* Header won't shrink */\n}\n\n.product-form-modal .modal-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.product-form-modal .modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #6b7280;\n}\n\n/* New wrapper for form content to handle flex structure */\n.product-form-modal .modal-form-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden; /* Prevents double scrollbars */\n}\n\n/* SCROLLABLE AREA */\n.product-form-modal .form-scroll-container {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto; /* Adds scrollbar here */\n  flex: 1; /* Takes available space */\n}\n\n.product-form-modal .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.product-form-modal .form-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.product-form-modal .form-group input,\n.product-form-modal .form-group textarea,\n.product-form-modal .form-group select {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 14px;\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.product-form-modal .form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n/* FIXED FOOTER */\n.product-form-modal .modal-footer {\n  padding: 16px 24px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #fff; /* Changed to white to blend better */\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n  flex-shrink: 0; /* Footer won't shrink */\n}\n\n.product-form-modal .cancel-btn,\n.product-form-modal .save-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid;\n}\n\n.product-form-modal .cancel-btn {\n  background-color: white;\n  color: #374151;\n  border-color: #d1d5db;\n}\n\n.product-form-modal .save-btn {\n  background-color: #f97316;\n  color: white;\n  border-color: #f97316;\n}\n\n.product-form-modal .save-btn:disabled {\n  background-color: #fdba74;\n  border-color: #fdba74;\n  cursor: not-allowed;\n}\n\n.navo-dialog .product-form-modal .modal-form-content { overflow: visible; }\n.navo-dialog .product-form-modal .form-scroll-container { padding: 0; overflow: visible; gap: 18px; }\n.product-stock-summary { display: flex; align-items: center; gap: 12px; padding: 12px 14px; border-radius: 10px; background: #f6f9fc; }\n.product-stock-summary p { margin: 0; font-size: 13px; line-height: 1.5; color: #64748b; }\n@media (max-width: 480px) { .product-form-modal .form-row { grid-template-columns: 1fr; } .product-stock-summary { align-items: flex-start; flex-direction: column; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
